import {allAttachments} from "../WeaponData";
import {useEffect, useState} from "react";
import {randomInt, useIsMobileHook} from "../../utils";
import DesktopAttachments from "./DesktopAttachmentsView";
import MobileAttachmentsView from "./MobileAttachmentsView";
import {RandomiseButton} from "../Weapons";

export const displaySlotName = (slot) => slot.replaceAll('_', ' ')
export const displayAttachmentName = (attachment) => attachment.name.split('[')[0]
export const slotsFull = (selectedAttachments) => Object.values(selectedAttachments).filter((s) => s != null).length > 4;


function Attachments({selectedWeapon, selectedAttachments, setSelectedAttachments, dialogOpen, setDialogOpen}) {

    const isMobile = useIsMobileHook()
    const [availableAttachments, setAvailableAttachments] = useState([])

    const handleAttachmentSelection = (attachment, slot) => {
        if (selectedAttachments[slot] === attachment) {
            selectedAttachments[slot] = null
        } else {
            if (slotsFull(selectedAttachments) && selectedAttachments[slot] == null) return
            selectedAttachments[slot] = attachment;
        }
        setSelectedAttachments({...selectedAttachments})
    };
    const randomAttachments = () => <RandomiseButton
        label='Random Attachments'
        onClick={() => {
            const slots = Object.keys(availableAttachments).filter((key) => availableAttachments[key].length > 0)
            while (slots.length > 5) { slots.splice(randomInt(slots.length), 1); }

            const selectedAttachments = {}
            slots.forEach((slot) => selectedAttachments[slot] = availableAttachments[slot][randomInt(availableAttachments[slot].length)])
            setSelectedAttachments({...selectedAttachments})
        }}
    />
    const removeAttachment = (slot) => {
        selectedAttachments[slot] = null
        setSelectedAttachments({...selectedAttachments})
    }

    useEffect(() => {
        if (selectedWeapon?.attachments == null) {
            setAvailableAttachments([]);
            return
        }
        let filteredAttachments = {...allAttachments}
        Object.keys(filteredAttachments)
            .forEach(type => filteredAttachments[type] = filteredAttachments[type].filter((a) => selectedWeapon.attachments.includes(a.id)))
        setAvailableAttachments(filteredAttachments)
    }, [selectedWeapon])

    return (
        isMobile ?
            <MobileAttachmentsView
                selectedWeapon={selectedWeapon}
                selectedAttachments={selectedAttachments}
                availableAttachments={availableAttachments}
                removeAttachment={removeAttachment}
                handleAttachmentSelection={handleAttachmentSelection}
                dialogOpen={dialogOpen}
                setDialogOpen={setDialogOpen}
                RandomAttachments={randomAttachments}
            />
            :
            <DesktopAttachments
                selectedWeapon={selectedWeapon}
                selectedAttachments={selectedAttachments}
                availableAttachments={availableAttachments}
                removeAttachment={removeAttachment}
                handleAttachmentSelection={handleAttachmentSelection}
                dialogOpen={dialogOpen}
                setDialogOpen={setDialogOpen}
                RandomAttachments={randomAttachments}
            />
    )
}

export default Attachments;
